import dataService from '../app.service'

const getWorklists = userId => {
  return dataService.get(`/search2/worklist/user/${userId}`)
}

const getWorklistById = worklistId => {
  return dataService.get(`/search2/worklist/${worklistId}`)
}

const postWorklist = (userId, data) => {
  return dataService.post(`/search2/worklist/user/${userId}`, data)
}

const shareWorklist = (worklistId, data) => {
  return dataService.put(`/search2/worklist/${worklistId}/sharing`, data)
}

const updateWorklist = (worklistId, data) => {
  return dataService.patch(`/search2/worklist/${worklistId}`, data)
}

const deleteWorklist = worklistId => {
  return dataService.delete('/search2/worklist/' + worklistId)
}

export default {
  getWorklists,
  getWorklistById,
  postWorklist,
  shareWorklist,
  updateWorklist,
  deleteWorklist,
}
